(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let revealObserver = null;

  if ('IntersectionObserver' in window && !reduceMotion) {
    revealObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
  }

  const bindReveals = (root = document) => {
    root.querySelectorAll('.reveal:not([data-reveal-bound])').forEach((element) => {
      if (!revealObserver || element.closest('.hero, .promise')) {
        element.classList.add('is-visible');
        return;
      }

      element.setAttribute('data-reveal-bound', 'true');
      revealObserver.observe(element);
    });
  };

  bindReveals();
  document.addEventListener('shopify:section:load', (event) => bindReveals(event.target));
})();

(() => {
  const menu = document.getElementById('SmoothcoDesktopMenu');
  const openButton = document.querySelector('[data-desktop-menu-open]');
  const mobileQuery = window.matchMedia('(max-width: 767px)');

  if (!menu || !openButton) return;

  const closeButtons = [...menu.querySelectorAll('[data-desktop-menu-close]')];
  const links = [...menu.querySelectorAll('a[href]')];
  const focusableSelector =
    'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

  let previousFocus = null;

  const isOpen = () => menu.getAttribute('aria-hidden') === 'false';

  const closeMenu = ({ restoreFocus = true } = {}) => {
    menu.setAttribute('aria-hidden', 'true');
    openButton.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('desktop-menu-open');

    if (restoreFocus && previousFocus instanceof HTMLElement) {
      previousFocus.focus();
    }
  };

  const openMenu = () => {
    if (!mobileQuery.matches || isOpen()) return;

    previousFocus = document.activeElement;
    menu.setAttribute('aria-hidden', 'false');
    openButton.setAttribute('aria-expanded', 'true');
    document.body.classList.add('desktop-menu-open');

    window.setTimeout(() => menu.querySelector(focusableSelector)?.focus(), 30);
  };

  openButton.addEventListener('click', openMenu);
  closeButtons.forEach((button) =>
    button.addEventListener('click', () => closeMenu())
  );
  links.forEach((link) =>
    link.addEventListener('click', () => closeMenu({ restoreFocus: false }))
  );

  document.addEventListener('keydown', (event) => {
    if (!isOpen()) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeMenu();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = [...menu.querySelectorAll(focusableSelector)].filter(
      (element) => element.offsetParent !== null
    );

    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  const handleBreakpoint = () => {
    if (!mobileQuery.matches) closeMenu({ restoreFocus: false });
  };

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', handleBreakpoint);
  } else {
    mobileQuery.addListener(handleBreakpoint);
  }

  handleBreakpoint();
})();

(() => {
  const openHashTarget = ({ scroll = false } = {}) => {
    if (!window.location.hash) return;

    const id = decodeURIComponent(window.location.hash.slice(1));
    const target = document.getElementById(id);

    if (!target) return;
    if (target.tagName === 'DETAILS') target.open = true;

    if (scroll) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;

    let url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (_) {
      return;
    }

    if (
      url.origin !== window.location.origin ||
      url.pathname !== window.location.pathname ||
      !url.hash
    ) {
      return;
    }

    const target = document.getElementById(
      decodeURIComponent(url.hash.slice(1))
    );

    if (!target) return;

    event.preventDefault();
    history.pushState(null, '', url.hash);

    if (target.tagName === 'DETAILS') target.open = true;

    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  });

  window.addEventListener('hashchange', () =>
    openHashTarget({ scroll: true })
  );
  window.addEventListener('load', () =>
    window.setTimeout(() => openHashTarget({ scroll: false }), 0)
  );
})();

/*
  Shopify Forms popup CTA safeguard.
  The old theme popup is removed. This only repairs the CTA inside the active
  Shopify Forms popup so "Shop the Routine" returns to the real storefront.
*/
(() => {
  const storefrontUrl = 'https://smoothify.store/#offer';

  const normalizeText = (value = '') =>
    value.replace(/\s+/g, ' ').trim().toLowerCase();

  const isPopupContext = (element) =>
    Boolean(
      element.closest(
        '[role="dialog"], [aria-modal="true"], [class*="popup" i], [class*="modal" i], [data-shopify-forms]'
      )
    );

  const isShopRoutineControl = (element) => {
    const text = normalizeText(element.textContent);
    const href = element.getAttribute?.('href') || '';

    return (
      text.includes('shop the routine') ||
      href.includes('/pages/shop-the-routine')
    );
  };

  const repairPopupLinks = (root = document) => {
    root
      .querySelectorAll?.(
        'a[href*="/pages/shop-the-routine"], [role="dialog"] a, [aria-modal="true"] a'
      )
      .forEach((link) => {
        if (
          link.getAttribute('href')?.includes('/pages/shop-the-routine') ||
          (isPopupContext(link) && isShopRoutineControl(link))
        ) {
          link.setAttribute('href', storefrontUrl);
        }
      });
  };

  document.addEventListener(
    'click',
    (event) => {
      const control = event.target.closest('a, button');
      if (!control || !isPopupContext(control) || !isShopRoutineControl(control)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      window.location.assign(storefrontUrl);
    },
    true
  );

  repairPopupLinks();

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        repairPopupLinks(node);
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();

/* Smoothco V22 — homepage About story carousel + scroll reveal */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initAboutSection = (section) => {
    if (!section || section.dataset.aboutReady === 'true') return;
    section.dataset.aboutReady = 'true';

    const slider = section.querySelector('[data-about-slider]');
    const slides = slider ? [...slider.querySelectorAll('[data-about-slide]')] : [];
    const dots = slider ? [...slider.querySelectorAll('[data-about-dot]')] : [];
    const previous = slider?.querySelector('[data-about-prev]');
    const next = slider?.querySelector('[data-about-next]');
    const interval = Math.max(3000, Number(slider?.dataset.aboutInterval || 5000));

    const reveal = () => section.classList.add('is-inview');

    if ('IntersectionObserver' in window && !reduceMotion) {
      const observer = new IntersectionObserver(
        (entries, currentObserver) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            reveal();
            currentObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.14, rootMargin: '0px 0px -8% 0px' }
      );
      observer.observe(section);
    } else {
      reveal();
    }

    if (!slider || slides.length < 2) return;

    let activeIndex = 0;
    let timer = null;
    let paused = false;

    const showSlide = (index, { userInitiated = false } = {}) => {
      activeIndex = (index + slides.length) % slides.length;

      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === activeIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === activeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });

      if (userInitiated) restart();
    };

    const stop = () => {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      if (reduceMotion || paused || document.hidden || timer) return;
      timer = window.setInterval(() => showSlide(activeIndex + 1), interval);
    };

    const restart = () => {
      stop();
      start();
    };

    previous?.addEventListener('click', () => showSlide(activeIndex - 1, { userInitiated: true }));
    next?.addEventListener('click', () => showSlide(activeIndex + 1, { userInitiated: true }));
    dots.forEach((dot) => {
      dot.addEventListener('click', () => showSlide(Number(dot.dataset.aboutDot), { userInitiated: true }));
    });

    slider.addEventListener('mouseenter', () => {
      paused = true;
      stop();
    });
    slider.addEventListener('mouseleave', () => {
      paused = false;
      start();
    });
    slider.addEventListener('focusin', () => {
      paused = true;
      stop();
    });
    slider.addEventListener('focusout', (event) => {
      if (slider.contains(event.relatedTarget)) return;
      paused = false;
      start();
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else start();
    });

    showSlide(0);
    start();
  };

  const initAllAboutSections = (root = document) => {
    root.querySelectorAll?.('[data-about-section]').forEach(initAboutSection);
  };

  initAllAboutSections();
  document.addEventListener('shopify:section:load', (event) => initAllAboutSections(event.target));
})();

/* Shopify Markets language selector */
(() => {
  document.addEventListener('change', (event) => {
    const selector = event.target.closest('[data-language-selector]');
    if (!selector) return;
    selector.form?.submit();
  });
})();

/* Smoothco V23 — site-wide premium scroll motion */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const revealImmediately = (root = document) => {
    root.querySelectorAll?.('[data-sc-motion]').forEach((element) => {
      element.classList.add('is-visible');
      element.dataset.scMotionReady = 'true';
    });
  };

  if (reduceMotion || !('IntersectionObserver' in window)) {
    revealImmediately();
    document.addEventListener('shopify:section:load', (event) => revealImmediately(event.target));
    return;
  }

  const observer = new IntersectionObserver(
    (entries, currentObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        currentObserver.unobserve(entry.target);
      });
    },
    {
      threshold: 0.12,
      rootMargin: '0px 0px -7% 0px',
    }
  );

  const bind = (root = document) => {
    root.querySelectorAll?.('[data-sc-motion]:not([data-sc-motion-ready])').forEach((element) => {
      element.dataset.scMotionReady = 'true';
      observer.observe(element);
    });
  };

  bind();
  document.addEventListener('shopify:section:load', (event) => bind(event.target));
})();

/* Smoothco V25 — premium About gallery (homepage + About page) */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const init = (section) => {
    if (!section || section.dataset.aboutV24Ready === 'true') return;
    section.dataset.aboutV24Ready = 'true';

    const gallery = section.querySelector('[data-about-v24-gallery]');
    if (!gallery) return;

    const slides = [...gallery.querySelectorAll('[data-about-v24-slide]')];
    const dots = [...section.querySelectorAll('[data-about-v24-dot]')];
    const prev = section.querySelector('[data-about-v24-prev]');
    const next = section.querySelector('[data-about-v24-next]');
    if (!slides.length) return;

    let active = 0;
    let timer = null;
    let paused = false;

    const mobile = () => window.matchMedia('(max-width: 767px)').matches;

    const show = (index, { scroll = true, restart = false } = {}) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === active));
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === active);
        dot.setAttribute('aria-current', i === active ? 'true' : 'false');
      });

      if (mobile() && scroll) {
        const target = slides[active];
        const left = target.offsetLeft - (gallery.clientWidth - target.offsetWidth) / 2;
        gallery.scrollTo({
          left: Math.max(0, left),
          behavior: reduceMotion ? 'auto' : 'smooth',
        });
      }

      if (restart) start(true);
    };

    const stop = () => {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    };

    const start = (forceRestart = false) => {
      if (forceRestart) stop();
      if (reduceMotion || paused || document.hidden || timer) return;
      timer = window.setInterval(() => show(active + 1, { scroll: mobile() }), 5200);
    };

    prev?.addEventListener('click', () => show(active - 1, { restart: true }));
    next?.addEventListener('click', () => show(active + 1, { restart: true }));
    dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.aboutV24Dot), { restart: true })));

    gallery.addEventListener('pointerenter', () => { paused = true; stop(); });
    gallery.addEventListener('pointerleave', () => { paused = false; start(); });
    gallery.addEventListener('focusin', () => { paused = true; stop(); });
    gallery.addEventListener('focusout', (event) => {
      if (gallery.contains(event.relatedTarget)) return;
      paused = false;
      start();
    });

    let scrollTick = null;
    gallery.addEventListener('scroll', () => {
      if (!mobile()) return;
      window.clearTimeout(scrollTick);
      scrollTick = window.setTimeout(() => {
        const center = gallery.scrollLeft + gallery.clientWidth / 2;
        let nearest = 0;
        let distance = Infinity;
        slides.forEach((slide, i) => {
          const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          const currentDistance = Math.abs(center - slideCenter);
          if (currentDistance < distance) {
            distance = currentDistance;
            nearest = i;
          }
        });
        show(nearest, { scroll: false });
      }, 80);
    }, { passive: true });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else start();
    });

    show(0, { scroll: false });
    start();
  };

  const bind = (root = document) => root.querySelectorAll?.('[data-about-v24]').forEach(init);
  bind();
  document.addEventListener('shopify:section:load', (event) => bind(event.target));
})();

/* Smoothco V33 — premium language toggle interaction */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const init = (root = document) => {
    root.querySelectorAll?.('[data-language-toggle]:not([data-language-ready])').forEach((form) => {
      form.dataset.languageReady = 'true';

      const hiddenInput = form.querySelector('[data-language-input]');
      const buttons = [...form.querySelectorAll('.sc-language-toggle__option')];
      if (!hiddenInput || !buttons.length) return;

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled || button.classList.contains('is-active')) return;

          const localeCode = button.dataset.localeCode;
          if (!localeCode) return;

          buttons.forEach((item) => item.classList.remove('is-target', 'is-pressed'));
          button.classList.add('is-pressed', 'is-target');
          form.classList.add('is-busy');
          document.documentElement.classList.add('is-switching-language');
          hiddenInput.value = localeCode;

          const submitDelay = reduceMotion ? 40 : 430;
          window.setTimeout(() => form.submit(), submitDelay);
        });

        button.addEventListener('animationend', () => {
          button.classList.remove('is-pressed');
        });
      });
    });
  };

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

/* Smoothco V33 — FAQ open animation boost */
(() => {
  const init = (root = document) => {
    root.querySelectorAll?.('.sc-faq__items details:not([data-faq-ready])').forEach((detail) => {
      detail.dataset.faqReady = 'true';
      const summary = detail.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', () => {
        detail.classList.remove('is-bursting');
        window.requestAnimationFrame(() => detail.classList.add('is-bursting'));
        window.setTimeout(() => detail.classList.remove('is-bursting'), 460);
      });
    });
  };

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
